import { Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AdminUsersForm from "./AdminUsersForm";
import AdminChangePassword from "./AdminChangePassword";

export const AdminUsersModal = ({
  open,
  handleClose,
  handleData,
  fetchAdminUserList,
}) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <AdminUsersForm
        handleClose={handleClose}
        handleData={handleData}
        fetchAdminUserList={fetchAdminUserList}
      />
    </Dialog>
  );
};

export const AdminChangePasswordModal = ({
  open,
  handleClose,
  newPasswordId,
}) => {
  return (
    <Dialog open={open} onClose={handleClose}>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <AdminChangePassword
        handleClose={handleClose}
        newPasswordId={newPasswordId}
      />
    </Dialog>
  );
};
